import script from "./voting-nomination-title.vue?vue&type=script&setup=true&lang=js"
export * from "./voting-nomination-title.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__